import { IssueResolverType, MessageV2DTO } from 'support/types';

/**
 * Decides whether the `ReviewBanner` should be hidden.
 *
 * Hidden when the message has been replaced — reviewing an older version
 * has no effect, and the `DuplicateAndChangeDocumentBanner` already points
 * the user to the newer version.
 *
 * Also hidden from the top banner slot when the annotation banner is taking
 * over: only for `document_requires_manual_review` messages (the only review
 * type whose actions are mirrored into the page header), only for the issue
 * resolver (annotations and their banners are issue-resolver-only), and only
 * when at least one unresolved annotation exists.
 */
export const shouldHideReviewBanner = (
  message: MessageV2DTO | undefined,
  issueResolver: IssueResolverType | undefined,
): boolean => {
  if (message?.replaced_by_message) {
    return true;
  }
  if (message?.review?.type !== 'document_requires_manual_review') {
    return false;
  }
  if (issueResolver !== IssueResolverType.CURRENT_PARTNER) {
    return false;
  }
  const hasUnresolvedAnnotations = message.annotations?.some((a) => a.resolved_at == null) ?? false;
  return hasUnresolvedAnnotations;
};
